module.exports = __webpack_public_path__ + "img/f3.ea2d7958.jpg";